import store from '../store';

import memberRoutes from './member';  // 交易模块
import orderRoutes from './order';  // 交易模块
import productRoutes from './product';  // 商品模块
import marketingRoutes from './marketing';  // 营销模块
import accountRoutes from './account';  // 资金模块
import analysisRoutes from './analysis';  // 数据模块
import systemRoutes from './system';  // 系统模块
import shopRoutes from './shop';  // 店铺模块

export default [{
	path: '/login',
	name: 'login',
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/authorize/:session',
	name: 'authorize',
	component: () => import('@/pages/login/authorize'),
	props: route => route.params
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [
		...memberRoutes,
		...orderRoutes,
		...productRoutes,
		...marketingRoutes,
		...accountRoutes,
		...analysisRoutes,
		...systemRoutes,
		...shopRoutes,
		{
			path: '',
			name: 'home',
			component: () => import('@/pages/home/index')
		}, {
			path: '404',
			component: () => import('@/pages/error/404')
		}
	]
}, {
	path: '/oss_manage',
	meta: {
		title: '图片空间'
	},
	component: () => import('@/submodule/oss_manage/index')
}, {
	path: '/decorate_manage/:type',
	meta: {
		title: '装修系统'
	},
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/submodule/decorate_manage/index')
}, {
	path: '/doc',
	component: () => import('@/pages/doc/index')
}, {
	path: '*',
	redirect: '/'
}];